import React, { useEffect } from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Col, Row } from 'react-bootstrap'

import CustomSelect from './CustomSelect'

function MaterialSelect({ className, displayErrors }) {

  const { Materials, selectedMaterial, setSelectedMaterial, materialIsValid } = ComponentData()

  return (
    <Col md={12}>
      <div className={displayErrors && !materialIsValid ? className + ' error' : className}>
        <Row className="headline_texts">
          <div className="configuration-text">
            <p>Werkstoff bestimmt die Wärmeleitfähigkeit</p>
            <h3>Werkstoff</h3>
          </div>
        </Row>
        <CustomSelect
          Items={Materials}
          value={selectedMaterial}
          setValue={setSelectedMaterial}
          placeholder={'Werkstoff wählen'} />
        {displayErrors && !materialIsValid ? <p className='error'>Werkstoff muss ausgewählt werden !</p> : null}
      </div>
    </Col >
  )
}

export default MaterialSelect